<template>
  <v-container grid-list-xs class="d-flex justify-center align-center my-10">
    <v-card class="card-width card-radius card-shadow my-16" elevation="0">
      <v-card-title
        primary-title
        class="dark-blue white--text title font-weight-medium px-10"
        >Rincian Pembayaran</v-card-title
      >
      <v-container class="py-8">
        <div class="content px-5">
          <expandable-image
            :src="require(`@/assets/img/rincian-1.png`)"
            class="image"
            alt="Rincian Pembayaran 1"
            :close-on-background-click="true"
          ></expandable-image>
          <expandable-image
            :src="require(`@/assets/img/rincian-2.png`)"
            class="image mt-5"
            alt="Rincian Pembayaran 2"
            :close-on-background-click="true"
          ></expandable-image>
        </div>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "RincianPembayaran",
};
</script>


<style scoped>
.dark-blue {
  background-color: #24305e !important;
}

.image {
  border: 1px solid #656565;
}

.card-text {
  font-size: 1.2rem;
}

.card-radius {
  border-radius: 10px !important;
}

.card-width {
  width: 60%;
}

.card-shadow {
  box-shadow: -2px -2px 4px rgba(0, 0, 0, 0.08), 2px 2px 4px rgba(0, 0, 0, 0.08) !important;
}

.berkas-section {
  min-height: 80vh;
}

@media screen and (max-width: 600px) {
  .card-width {
    width: 100%;
  }
}
</style>